import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

/* ─── Digit-box inline styles — matches freevisitorcounters.com look ─── */
const styles = {
  visitorWrap: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    marginTop: '6px',
  },
  label: {
    color: '#ccc',
    fontSize: '12px',
    letterSpacing: '0.5px',
  },
  digitContainer: {
    display: 'inline-flex',
    border: '1px solid #888',
    borderRadius: '3px',
    overflow: 'hidden',
    background: '#555',       /* medium gray outer gap between cells */
    background: '#ffffff',//'#606060',    /* medium-dark gray cell — matches target screenshot */
    gap: '1px',               /* the thin gray divider line between digits */

  },
  digit: {
    display: 'inline-block',
    width: '26px',
    height: '28px',
    lineHeight: '28px',
    textAlign: 'center',
    // background: '#606060',    /* medium-dark gray cell — matches target screenshot */
    // color: '#ffffff',

    background: '#ffffff',//'#606060',    /* medium-dark gray cell — matches target screenshot */
    color: '#606060',//#ffffff',

    fontSize: '16px',
    fontWeight: '600',
    fontFamily: "'Arial', sans-serif",
    letterSpacing: '0px',
  },
};


/* Pad number to at least 7 digits, split into individual chars */
const toDigits = (num) =>
  String(num ?? 0).padStart(7, '0').split('');

const Footer = () => {
  const [visitorCount, setVisitorCount] = useState(null);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    // Only fetch visitor count on the home page
    if (!isHomePage) return;

    const SESSION_KEY = 'hhp_visited';
    const alreadyCounted = sessionStorage.getItem(SESSION_KEY);

    if (!alreadyCounted) {
      // ── Set the flag SYNCHRONOUSLY before the async fetch ──
      // This prevents React StrictMode's double-invocation (or any
      // accidental re-run) from firing a second POST before the first
      // fetch resolves, which was causing the count to jump by 2.
      sessionStorage.setItem(SESSION_KEY, '1');

      fetch('/api/public/visitor/track', { method: 'POST' })
        .then((r) => r.json())
        .then((data) => setVisitorCount(data.count))
        .catch(() => {
          // If the request fails, clear the flag so the next real
          // page load can try again.
          sessionStorage.removeItem(SESSION_KEY);
          setVisitorCount(null);
        });
    } else {
      // Already counted this session → just fetch display value
      fetch('/api/public/visitor/count')
        .then((r) => r.json())
        .then((data) => setVisitorCount(data.count))
        .catch(() => setVisitorCount(null));
    }
  }, [isHomePage]);

  return (
    <footer
      className="footer-wrapper footer-layout2"
      data-bg-src="/web/assets/img/bg/footer_bg_2.png"
      style={{ paddingTop: '40px' }}
    >
      <div className="widget-area">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-md-4 col-xxl-5 col-xl-4">
              <div className="widget footer-widget">
                <h3 className="widget_title">Information</h3>
                <div className="th-widget-about">
                  <p className="about-text">
                    Sri AdiShankaracharya Sharada Lakshminarasimha Peetam, an
                    ancient Dharmapeetam directly established by Jagadguru Sri
                    AdiShankaracharya, is situated at the Divyakshetra of
                    Hariharapura in Chikmagalur District, Karnataka
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-2 col-xxl-2 col-xl-2">
              <div className="widget widget_nav_menu footer-widget">
                <h3 className="widget_title">Services</h3>
                <div className="menu-all-pages-container">
                  <ul className="menu">
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/about">About</Link></li>
                    {/* <li><Link to="/booking-seva">Sevas</Link></li> */}
                    <li><Link to="/yearly-activities">Activities</Link></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-2 col-xxl-2 col-xl-2">
              <div className="widget widget_nav_menu footer-widget">
                <h3 className="widget_title">Quick Links</h3>
                <div className="menu-all-pages-container">
                  <ul className="menu">
                    {/* <li><Link to="/gallery">Gallery</Link></li>
                      <li><Link to="/publications">Publications</Link></li>
                      <li><Link to="/contact">Contact Us</Link></li>
                      <li><Link to="/bookingroom">Guest-House</Link></li> */}
                    <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                    <li><Link to="/terms-conditions">Terms &amp; Conditions</Link></li>
                    <li><Link to="/refund-policy">Refund Policy</Link></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-xxl-3 col-xl-3">
              <div className="widget footer-widget">
                <h3 className="widget_title">Contact Us</h3>
                <div className="th-widget-about">
                  <p className="footer-info">
                    <i className="fa-sharp fa-solid fa-phone"></i>
                    <span>
                      <a className="text-inherit" href="tel:9019977466">
                        +91 901 997 7466
                      </a>
                    </span>
                  </p>
                  <p className="footer-info">
                    <i className="fa-sharp fa-solid fa-envelope"></i>
                    <span>
                      <a className="text-inherit" href="mailto:hhpuraoff@gmail.com">
                        hhpuraoff@gmail.com
                      </a>
                    </span>
                  </p>
                  <p className="footer-info">
                    <i className="fas fa-map-marker-alt"></i>
                    Hariharapura, Chikmagalur district,
                    <br />
                    Karnataka, India - 577120
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="copyright-wrap">
        <div className="container">
          <div className="row gy-2 align-items-center">
            <div className="col-lg-5">
              <p className="copyright-text" style={{ marginBottom: '4px' }}>
                Copyright
                <i className="fal fa-copyright"> </i>
                2026. All Rights Reserved.
              </p>

              {/* ── Visitor Counter (Home page only) ── */}
              {isHomePage && visitorCount !== null && (
                <div style={styles.visitorWrap}>
                  <span style={styles.label}>Visitors:</span>
                  <div style={styles.digitContainer}>
                    {toDigits(visitorCount).map((d, i, arr) => (
                      <span
                        key={i}
                        style={styles.digit}
                      >
                        {d}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div className="col-lg-7 text-center text-lg-end">
              <div className="social-links">
                <span className="title">Social Media:</span>
                <a href="https://www.facebook.com/share/17YvF8L42f/" target="_blank" rel="noreferrer">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="https://www.instagram.com/hariharapurmath?igsh=c2Z1d2pod2d6b2w2" target="_blank" rel="noreferrer">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="https://whatsapp.com/channel/0029Vb5hOsPId7nDh5SDJO1Z" target="_blank" rel="noreferrer">
                  <i className="fab fa-whatsapp"></i>
                </a>
                <a href="https://youtube.com/@hariharapurmath?si=4tvE7Xxv87cdcoHx" target="_blank" rel="noreferrer">
                  <i className="fab fa-youtube"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
